/* eslint-disable jsx-a11y/alt-text */
import { useArtistsHeader } from 'api/artists'
import { ArtistHeaderMobileCarousel } from 'components/carousels/ArtistHeaderMobileCarousel'
import useTranslation from 'next-translate/useTranslation'
import { Artist } from 'utils/data'
import { ArtistHeaderCardMobile } from './ArtistHeaderCardMobile'
import { ArtistHeaderCard } from './ArtistHeaderCard'

export type ArtistCardProps = {
  initialArtists?: Artist[] | null
}

export const ArtistsHeader = ({ initialArtists }: ArtistCardProps) => {
  const { t } = useTranslation()

  const { data: artists, isFetching } = useArtistsHeader(initialArtists)

  const isProduction = process.env.NEXT_PUBLIC_STAGE === 'production'

  const productionIds = [1289, 1373, 1241, 1229, 1429, 1438, 1358, 1337, 1392]
  const developmentIds = [1229, 1347, 1228, 1213, 1437, 1455, 1337, 1285, 1385]

  const artistIds = isProduction ? productionIds : developmentIds

  const sortedArtists = artistIds.map(id => artists?.find(a => a?.id === id))

  const productionMobileIds = [
    [1289, 1229, 1358],
    [1373, 1429, 1337],
    [1241, 1438, 1392],
  ]

  const developmentMobileIds = [
    [1229, 1213, 1337],
    [1347, 1437, 1455],
    [1228, 1285, 1385],
  ]

  const mobileArtistIds = isProduction
    ? productionMobileIds
    : developmentMobileIds

  const mobileArtists =
    artists &&
    mobileArtistIds.map(group =>
      group.map(id => artists.find(a => a?.id === id))
    )

  return (
    <>
      <div className='hidden bg-[#F5F5F5] py-7 lg:block md-lg:block'>
        <div className='container w-full'>
          <span className='mb-6 flex items-end justify-start'>
            <span className='pr-[24px] text-3xl leading-none text-cool-900'>
              {t('artists:artists')}
            </span>
            <span className='flex items-end text-lg font-normal text-cool-600'>
              {t('artists:artists_desc')}
            </span>
          </span>
          <div className='relative'>
            {[1, 2].map(i => (
              <div
                key={i}
                className={`absolute right-[32.5%] hidden h-full w-[1px] bg-cool-400 ${
                  i === 1
                    ? 'left-1/2 md:block lg:left-[32.5%] md-lg:left-[50%]'
                    : 'right-[32.5%] lg:block md-lg:hidden'
                }
                `}
              />
            ))}

            <div className='grid grid-cols-3 gap-4 gap-x-[64px] md-lg:grid-cols-2'>
              {sortedArtists?.map((artist, index) => {
                return (
                  <ArtistHeaderCard
                    key={artist?.id}
                    artist={artist}
                    isFetching={isFetching}
                    index={index}
                  />
                )
              })}
            </div>
          </div>
        </div>
      </div>

      <div className='block bg-[#F5F5F5] px-6 pt-4 lg:hidden md-lg:hidden'>
        <div className='mb-4'>
          <div className='text-xl font-medium text-cool-900'>
            {t('artists:artists')}
          </div>
          <div className='text-sm font-normal text-cool-600'>
            {t('artists:artists_desc_mobile')}
          </div>
        </div>
        <ArtistHeaderMobileCarousel
          slides={[
            {
              priority: true,
              loading: 'eager',
              reversed: true,
              content: (
                <>
                  {mobileArtists?.[0].map(artist => {
                    return (
                      <ArtistHeaderCardMobile
                        key={artist?.id}
                        artist={artist}
                        isFetching={isFetching}
                      />
                    )
                  })}
                </>
              ),
            },
            {
              content: (
                <>
                  {mobileArtists?.[1].map(artist => {
                    return (
                      <ArtistHeaderCardMobile
                        key={artist?.id}
                        artist={artist}
                        isFetching={isFetching}
                      />
                    )
                  })}
                </>
              ),
            },
            {
              reversed: true,
              content: (
                <>
                  {mobileArtists?.[2].map(artist => {
                    return (
                      <ArtistHeaderCardMobile
                        key={artist?.id}
                        artist={artist}
                        isFetching={isFetching}
                      />
                    )
                  })}
                </>
              ),
            },
          ]}
        />
      </div>
    </>
  )
}
